import axios from "axios";

type TGetAllEvents = {
  accessToken: string | null;
  leadId: string
  setIsFetching?: React.Dispatch<React.SetStateAction<boolean>>;
  setTokenLikeExpired?: () => void;
}

export default async function getOneLead({ 
  accessToken,
  leadId,
  setTokenLikeExpired,
  setIsFetching,
 }: TGetAllEvents) {
  try {
    if(setIsFetching) setIsFetching(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_LEAD_API_URL}/get-one/${leadId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return err;
  } finally {
    if (setIsFetching) setIsFetching(false)
  }
}